import styled from "styled-components"
import { ContentWrapper as GlobalContentWrapper } from "../../ui/content-wrapper/content-wrapper-elements"
import {
  SectionWrapperStyles,
  BackgroundWrapperStyles,
  BackgroundStyles,
  ContentWrapperStyles,
  ContentStyles,
  ContentDescriptionStyles,
  ContentButtonsStyles,
} from "./not-full-width-banners-styles"
import { BreakPoints, media } from "../../helpers/rwd"
import { colors } from "../../components/top-bar/core/colors"
import { mozillaFontAlignFix } from "../../helpers/mozilaFontAlignFix"

interface IBackgroundWrapper {
  imgSrc: string
}

export const SectionWrapper = styled.section`
  padding: 40px 0;
  ${SectionWrapperStyles}
`

export const RowWrapper = styled.section`
  display: flex;
  position: relative;
  width: 100%;
  max-width: 1253px;
  margin: 0 auto;
  min-height: 424px;
  ${media.max(BreakPoints.lgDesktop)} {
    max-width: 1083px;
  }
  ${media.max(BreakPoints.desktop)} {
    max-width: 889px;
  }
  ${media.max(BreakPoints.smallDesktop)} {
    max-width: none;
    width: 90%;
  }
  ${media.max(BreakPoints.tablet)} {
    width: 100%;
    max-width: 503px;
  }

  ${media.max(BreakPoints.phone)} {
    padding: 0 13px;
    overflow: hidden;
  }
`

export const BackgroundWrapper = styled.div`
  display: flex;
  position: absolute;
  align-items: stretch;
  width: 100%;
  height: 100%;
  z-index: 1;
  flex-direction: column;
  ${BackgroundWrapperStyles}
`

export const Background = styled.div<IBackgroundWrapper>`
  background-image: url(${props => props.imgSrc});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  transition: all .3s ease-in-out;
  width: 100%;
  max-width: 495px;
  &:first-child {
    max-width: none;
  }
  &:last-child {
    max-width: none;
  }
  margin: 13px 0;
  height: 100%;

  &:hover{
    background-size: 120%;
  }
  ${BackgroundStyles}
`

export const ContentWrapper = styled(GlobalContentWrapper)`
  display: flex;
  align-items: center;
  height: auto;
  z-index: 2;
  padding:0;
  ${media.max(BreakPoints.desktop)} {
    flex-direction: column;
  }
  ${ContentWrapperStyles}

  ${media.max(BreakPoints.tablet)} {
    margin-top: 32%;
    min-height: auto;
  }

  ${media.max(BreakPoints.phone)} {
    width: 100%;
  }
`
export const BannerInfoWrapper = styled.div<{background: string}>`
  max-width: 428px;
  background: ${({background}) => background ? background : "rgba(0,0,0,.6)"};
  height: 100%;
  display:flex;
  flex-direction: column;
  align-items: center;
  margin: 13px -1px 13px auto;
  ${media.max(BreakPoints.tablet)} {
    margin: 21px 0 16px;
    max-width: 503px;
  }
  ${media.max(BreakPoints.phone)} {
  }
`

export const Content = styled.div`
  display: flex;
  width: 100%;
  margin: 0px;
  height: 100%;
  text-align: center;
  flex-direction: column;
  &:first-child {
    margin-left: 0;
  }
  &:last-child {
    margin-right: 0;
  }
  ${media.max(BreakPoints.desktop)} {
    margin-left: 0;
    margin-right: 0;
  }
  ${ContentStyles}
`

export const BannerInfoHeader = styled.h3`
  margin: 15px 13px;
  padding: 0 16px;
  font-family: 'Roboto', sans-serif;
  font-weight: 900;
  font-size: 3em;
  text-transform: uppercase;
  line-height: 1.15em;
  ${media.max(BreakPoints.tablet)} {
    font-size: 2.1em;
    margin: 10px 13px;
  }
`

export const ContentDescription = styled.p`
  margin: 30px 0;
  ${ContentDescriptionStyles}
`

export const LogoWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 16px;
  align-items: center;
`

export const Label = styled.span<{color?: string}>`
  background: ${({color}) => color ? color : 'black'};
  width: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 23px;
  text-align: center;
  color: ${colors.purple};
  text-transform: uppercase;
  font-weight: 700;
  font-size: 0.9rem;
  padding: 4px 8px 0px;
  margin-left: -16px;
  ${mozillaFontAlignFix} {
    padding: 6px 8px 4px;
  }
`

export const GameLogo = styled.img`
  max-height: 56px;
  justify-content: end;
`

export const ContentButtons = styled.div`
  display: flex;
  flex-direction: column;
  margin: auto 0 31px;
  & > a {
    min-height: 36px !important;
    padding: 13px 13px 8px 13px;
    margin: 10px 0;
  }
  ${media.max(BreakPoints.tablet)} {
    flex-wrap: wrap;
  }
  ${ContentButtonsStyles}
`
